<template>
	<transition name="modal">
		<div class="modal-mask modal">
			<div class="modal-wrapper" @click="closeModal()">
				<div class="modal-dialog modal-lg">
					<div class="modal-content" @click.stop>
						<div class="modal-header">
							<div class="col-lg-12 dynvibeTitleBox" style="padding-bottom: 10px; margin-bottom: 0px">
								<h5 class="modal-title" id="dynvibeGraphDetailsTitle">
									Advanced Search
									<button type="button" class="close" @click="closeModal()" style="outline: 0">
										<span aria-hidden="true"><i class="icon-x"></i></span>
									</button>
								</h5>
							</div>
						</div>
						<div class="modal-body">
							<div class="row dynvibeRow">
								<div class="col-lg-12">
									<div class="dynvibeBox" style="min-height: 150px">
										<div class="col-lg-12 dynvibeModalAdvancedSearchField" style="border-top: none">
											<div class="col-lg-3">
												<select
													class="dynvibeModalAdvancedSearchInput dynvibeListMastertags"
													v-model="filterMastertag"
												>
													<option value="">Mastertags</option>
													<option v-for="mastertag in mastertags" v-bind:key="mastertag" :value="mastertag">
														{{ mastertag }}
													</option>
												</select>
											</div>
											<div class="col-lg-2">
												<span
													class="dynvibeModalAdvancedSearchInputAdd icon-plus"
													@click="addFilterMastertag()"
												></span>
											</div>
											<div class="col-lg-7">
												<div v-if="filterMastertags.length === 0" class="dynvibeModalAdvancedSearchWords"></div>
												<div v-else>
													<div v-for="mastertag in filterMastertags" v-bind:key="mastertag">
														<div class="dynvibeModalAdvancedSearchWords">
															<div
																class="dynvibeModalAdvancedSearchWord"
																@click="removeFilterMastertag(mastertag)"
															>
																<span>"{{ mastertag }}"</span><i class="icon-x"></i>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="col-lg-12 dynvibeModalAdvancedSearchField" data-search-type="includeWords">
											<div class="col-lg-3">
												<input
													class="dynvibeModalAdvancedSearchInput"
													v-model="includeWord"
													placeholder="Include words"
													type="text"
													maxlength="50"
												/>
											</div>
											<div class="col-lg-2">
												<span class="dynvibeModalAdvancedSearchInputAdd icon-plus" @click="addIncludeWord()"></span>
												<span class="dynvibeModalAdvancedSearchInputOr"
													><span style="text-align: center; width: 100%" @click="addOr()">OR</span></span
												>
											</div>
											<div class="col-lg-7">
												<div v-if="includeWords.length === 0" class="dynvibeModalAdvancedSearchWords"></div>
												<div v-else>
													<div v-for="(andWords, index) in includeWords" v-bind:key="index">
														<div
															v-if="index > 0"
															@click="removeOr(index)"
															class="dynvibeModalAdvancedSearchWordOr"
														>
															<div>OR<span class="icon-x"></span></div>
														</div>
														<div class="dynvibeModalAdvancedSearchWords">
															<div v-for="word in andWords" v-bind:key="word">
																<div
																	class="dynvibeModalAdvancedSearchWord"
																	@click="removeIncludeWord(word, index)"
																>
																	<span>"{{ word }}"</span><i class="icon-x"></i>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="col-lg-12 dynvibeModalAdvancedSearchField">
											<div class="col-lg-3">
												<input
													class="dynvibeModalAdvancedSearchInput"
													v-model="excludeWord"
													placeholder="Exclude words"
													type="text"
													maxlength="50"
												/>
											</div>
											<div class="col-lg-2">
												<span class="dynvibeModalAdvancedSearchInputAdd icon-plus" @click="addExcludeWord()"></span>
											</div>
											<div class="col-lg-7">
												<div class="dynvibeModalAdvancedSearchWords"></div>
												<div class="col-lg-7">
													<div v-if="excludeWords.length === 0" class="dynvibeModalAdvancedSearchWords"></div>
													<div v-else>
														<div v-for="word in excludeWords" v-bind:key="word">
															<div class="dynvibeModalAdvancedSearchWords">
																<div
																	class="dynvibeModalAdvancedSearchWord"
																	@click="removeExcludeWord(word)"
																>
																	<span>"{{ word }}"</span><i class="icon-x"></i>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button class="btn-success dynvibeModalAdvancedSearchFooterBtn" @click="applyFilters()">Apply</button>
							<button class="btn-danger dynvibeModalAdvancedSearchFooterBtn" @click="closeModal()">Cancel</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "Advanced Filters",
	emits: ["applyadvancedfilter", "closemodal"],
	props: {
		/*        options: {
            },*/
		mastertags: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			filterMastertags: [],
			filterMastertag: "",
			includeWords: [[]],
			includeWord: "",
			excludeWords: [],
			excludeWord: "",
		};
	},
	mounted() {
		/*        this.filterMastertags = this.options.mastertags ? this.options.mastertags[0] : []
            this.excludeWords = this.options.excludeWords ? this.options.excludeWords[0] : []
            this.includeWords = this.options.includeWords ? this.options.includeWords : [[]]*/
	},
	methods: {
		applyFilters() {
			let tmp = [];
			tmp.mastertags = [this.filterMastertags];
			tmp.excludeWords = [this.excludeWords];
			tmp.includeWords = this.includeWords;
			this.$emit("applyadvancedfilter", tmp);
			this.excludeWord = "";
		},
		addFilterMastertag() {
			if (!this.filterMastertags) {
				this.filterMastertags = [this.filterMastertag];
			} else if (!this.filterMastertags.includes(this.filterMastertag)) {
				this.filterMastertags.push(this.filterMastertag);
			}
		},
		addExcludeWord() {
			if (!this.excludeWords) {
				this.excludeWords = [this.excludeWord];
			} else if (!this.excludeWords.includes(this.excludeWord)) {
				this.excludeWords.push(this.excludeWord);
			}
			this.excludeWord = "";
		},
		addIncludeWord() {
			let word = this.includeWord;
			let lastAndGroup = this.includeWords[this.includeWords.length - 1];
			if (!lastAndGroup.includes(word)) {
				lastAndGroup.push(word);
			}
		},
		addOr() {
			if (this.includeWords[this.includeWords.length - 1].length > 0) {
				this.includeWords.push([]);
			}
		},
		removeFilterMastertag(mastertag) {
			this.filterMastertags = this.filterMastertags.filter((filterMastertag) => filterMastertag !== mastertag);
		},
		removeExcludeWord(word) {
			this.excludeWords = this.excludeWords.filter((excludedWord) => excludedWord !== word);
		},
		removeIncludeWord(word, andIndex) {
			let andGroup = this.includeWords[andIndex];
			andGroup = andGroup.filter((andWord) => andWord !== word);
			if (andGroup.length === 0 && this.includeWords.length > 1) {
				this.includeWords.splice(andIndex, 1);
			} else {
				// Instead of "this.includeWords[andIndex] = andGroup" because else it is not reactive
				this.includeWords[andIndex] = andGroup;
				//Vue.set(this.includeWords, andIndex, andGroup)
			}
		},
		removeOr(andIndex) {
			// There is at least another andGroup (the first one) so we just remove this one
			this.includeWords.splice(andIndex, 1);
		},
		closeModal() {
			this.excludeWord = "";
			this.$emit("closemodal");
		},
		resetFilters() {
			this.filterMastertags = [];
			this.filterMastertag = "";
			this.includeWords = [[]];
			this.includeWord = "";
			this.excludeWords = [];
			this.excludeWord = "";
		},
	},
};
</script>
